<!--
  @description: 分页器组件.
  @param
    config(Object): 配置项;
      pageNo(Number): 当前页码
      pageSize(Number): 默认每页数据量
      total(Number): 总数据量
    pageSizeOptions(string[]): 每页数据量选择列表
    align(String): 排列方式，同text-align
    showText(Boolean): 显示左侧文字
    changeCallback(Function): 回调函数
    other(//www.antdv.com/components/pagination-cn/#API)
  @event
    change: 分页器配置改变时触发
    other(//www.antdv.com/components/pagination-cn/#事件)
  @author: suzichen
-->
<template>
  <a-pagination
    show-size-changer
    show-quick-jumper
    show-less-items
    :size="'small'"
    :current="config.pageNo"
    :total="config.total"
    :page-size="config.pageSize"
    :page-size-options="pageSizeOptions"
    :show-total="getText"
    :style="{ textAlign: align }"
    v-bind="$props"
    @change="handleChange"
    @showSizeChange="handleSizeChange"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'PageTo',
  props: {
    config: {
      type: Object,
      default () {
        return {
          pageNo: 1, // 当前页
          pageSize: 20, // 默认每页数据量
          total: 20 // 总数据量
        }
      }
    },
    pageSizeOptions: {
      type: Array[String],
      default () {
        return ['20', '50', '100', '200', '500', '1000']
      }
    },
    align: {
      type: String,
      default: 'left'
    },
    showText: {
      type: Boolean,
      default: false
    },
    changeCallback: {
      type: Function
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    getText (total, range) {
      const { pageNo, pageSize } = this.config
      const totalPage = Math.ceil(total / pageSize) || 0
      return this.showText ? `共 ${total} 条记录 第 ${pageNo} / ${totalPage} 页` : ''
    },
    handleChange (pageNo, pageSize) {
      // eslint-disable-next-line vue/no-mutating-props
      this.config.pageNo = pageNo
      // eslint-disable-next-line vue/no-mutating-props
      this.config.pageSize = pageSize
      this.doCallBack()
    },
    handleSizeChange (pageNo, pageSize) {
      this.handleChange(pageNo, pageSize)
      this.$emit('change', pageNo, pageSize)
    },
    doCallBack () {
      if (!this.changeCallback) return false
      const { pageNo, pageSize } = this.config
      const ret = this.changeCallback({ pageNo, pageSize })
      if (!ret || !ret.then) return false
      ret.then(res => {
        // eslint-disable-next-line vue/no-mutating-props
        this.config.total = res.total
        // eslint-disable-next-line vue/no-mutating-props
        this.config.pageNo = res.pageNo || 1
        // eslint-disable-next-line vue/no-mutating-props
        this.config.pageSize = res.pageSize || 20
      }).catch(() => {})
    }
  },
  mounted () {
    this.doCallBack()
  }
}
</script>

<style lang="less" scoped>
@deep: ~'>>>';
@{deep} .ant-pagination-item {
  padding: 0 4px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: normal;
  border: none;
  a {
    color: rgba(51, 51, 51, 0.85);
  }
}
@{deep} .ant-pagination-item-active {
  font-weight: normal;
  background-color: #f5f5f6;
  a {
    color: #00a497;
  }
}
@{deep} .ant-pagination-options-size-changer.ant-select {
  margin: 0 14px 0 20px;
}
.ant-pagination.mini .ant-pagination-options-quick-jumper {
  height: auto;
}
</style>
